import { Outlet } from "react-router-dom";

export default function ProductManagementOutlet() {
  return <Outlet />;
}
